/**
 * Toggle discount_price promo blocks by selected variant (data-dp-variant-ids).
 */
(function () {
  function getVariantIdFromEvent(event) {
    const variant = event?.data?.variant;
    if (!variant) return null;
    if (typeof variant === 'object') {
      if ('id' in variant && variant.id != null) return String(variant.id);
      if ('value' in variant && variant.value != null) return String(variant.value);
    }
    if (typeof variant === 'string' || typeof variant === 'number') return String(variant);
    return null;
  }

  function updateDiscountPriceByVariant(variantId) {
    if (!variantId) return;

    document.querySelectorAll('[data-dp-variant-ids]').forEach((el) => {
      const ids = (el.getAttribute('data-dp-variant-ids') || '')
        .split(',')
        .map((id) => id.trim())
        .filter(Boolean);

      if (!ids.length) return;

      const show = ids.includes(String(variantId));
      el.classList.toggle('hidden', !show);
    });
  }

  function initDiscountPriceByVariant() {
    const variantInput = document.querySelector('product-info .product-variant-id');
    if (variantInput?.value) {
      updateDiscountPriceByVariant(variantInput.value);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDiscountPriceByVariant);
  } else {
    initDiscountPriceByVariant();
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variantId = getVariantIdFromEvent(event);
      updateDiscountPriceByVariant(variantId);
    });
  }
})();
